import * as yup from 'yup';

const NOT_A_NUMBER = 'Must be a number';
const NOT_WHOLE = 'Must be a whole number';

/**
 * yup casts an empty string to NaN, so a blank field has to become "nothing"
 * before the number rules run. Everything else keeps what was typed, so text is
 * reported as text instead of quietly reading as absent — which for a usage
 * limit would have meant "unlimited".
 */
const blankTo = (empty) => (value, original) =>
  original === '' || original === null || original === undefined
    ? empty
    : value;

const blankToNull = blankTo(null);
const blankToUndefined = blankTo(undefined);

/** A whole number, or blank when the field is allowed to be left out. */
export const optionalCount = ({
  min = 1,
  minMessage = `Must be at least ${min}`,
} = {}) =>
  yup
    .number()
    .transform(blankToNull)
    .nullable()
    .typeError(NOT_A_NUMBER)
    .integer(NOT_WHOLE)
    .min(min, minMessage);

/** A money value, or blank when the field is allowed to be left out. */
export const optionalAmount = ({
  min = 0,
  minMessage = `Must be ${min} or more`,
} = {}) =>
  yup
    .number()
    .transform(blankToNull)
    .nullable()
    .typeError(NOT_A_NUMBER)
    .min(min, minMessage);

export const requiredCount = ({
  min = 1,
  minMessage = `Must be at least ${min}`,
} = {}) =>
  yup
    .number()
    .transform(blankToUndefined)
    .typeError(NOT_A_NUMBER)
    .required(NOT_A_NUMBER)
    .integer(NOT_WHOLE)
    .min(min, minMessage);

export const requiredAmount = ({
  min = 0,
  max,
  minMessage = `Must be ${min} or more`,
  maxMessage = `Must be ${max} or less`,
} = {}) => {
  const rule = yup
    .number()
    .transform(blankToUndefined)
    .typeError(NOT_A_NUMBER)
    .required(NOT_A_NUMBER)
    .min(min, minMessage);
  return max === undefined ? rule : rule.max(max, maxMessage);
};
